import { h } from 'preact'
import Button from '../../control-components/ui-components/Button'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import { t } from '../../libs/translationsUtils/translations'

interface Props {
  onRequest: () => void,
  isLoading: boolean,
  requestPending: boolean
}

const PrivateGroupPlaceholder = ({isLoading, onRequest, requestPending}: Props) => (
  <div className='group-private__placeholder'>
    <div className='group-content-container'>
      { !requestPending && (
        <div>
          <Icon customClass={'icon-locked'} icon={'locked'} />
          <h3>
            <span dangerouslySetInnerHTML={{ __html: t('Forum', 'groups.request.to.join.private.group') }} />
          </h3>
          <div className='group-private__call-to-action'>
            <Button
              type='button'
              class='btn--cta'
              loading={isLoading}
              onClick={onRequest}
            ><Phrase p='groups.request.to.join' /></Button>
          </div>
        </div>)
      }
      { requestPending && (
        <div>
          <Icon customClass={'icon-clockDestination'} icon={'clockDestination'} />
          <h3><Phrase p='groups.request.is.sent' /></h3>
        </div>)
      }
    </div>
  </div>
)

export default PrivateGroupPlaceholder
